<template>
  <div id="nav-top" class="w-full h-16  shadow relative flex items-center justify-center px-5 bg-white text-app-black border-t border-b">
    <div class="h-full flex justify-center items-center  mb-0.5 cursor-pointer" @click.prevent="backFunc">
      <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 1L1 9L9 17" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <div class="w-full flex flex-col">
      <div>
        <div 
          @click="clickToShowSecret"
          class="w-full text-center text-lg md:text-xl" 
          :style="{
            color: color
          }">
          {{ label }}
        </div>
      </div>
    </div>




    <div class="absolute right-5 top-4" v-if="isShowDebugButton">
      <button @click="openDebugUI" class="text-2xl text-gray-400"><i class="fa-solid fa-bug"></i></button>
    </div>
  </div>
</template>


<script lang="ts" setup>
  import { useDebugStore } from '~/store/debug'
  import { useAppStateStore } from '~/store/appState'
  defineProps({
    label: { type: String, required: true },
    color: { type: String, default: "#0855cb"},
    backFunc: { type: Function},
    step: { type: Object }
  })

  const isShowDebugButton = computed(() => useDebugStore().isDebug)
  const appStateStore = useAppStateStore()

  const openDebugUI = () => {
    useDebugStore().showUi = true
  }

  // secret click 10 times in 5 seconds to open vconsole
  const count = ref(0)
  const setTimeoutRef = ref(null)
  const clickToShowSecret = () => {
    if (count.value > 0) {
      count.value += 1;
    } else {
      count.value += 1;
      setTimeoutRef.value = setTimeout(() => {
        count.value = 0;
      }, 5000);
    }

    if (count.value >= 10) {
      clearTimeout(setTimeoutRef.value);
      console.log(`Wow, you clicked ${count.value} times in 5 seconds`);

      appStateStore.vConsoleInstance?.showSwitch()
      setTimeout(() => {
        appStateStore.vConsoleInstance?.show()
      }, 500);
      count.value = 0;
      return;
    }
  }


</script>


<style scoped>

</style>